import { PartialType } from '../../../../utils';
import { CreateVehicleModelKeyOptionDto } from '../create';
export class UpdateVehicleModelKeyOptionDto extends PartialType(CreateVehicleModelKeyOptionDto) {
}
